module.exports = __webpack_public_path__ + "img/banner.324675c3.jpg";